import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPaymentMastercard = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconPaymentMastercard",
  viewBox: "0 0 22 16",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    fill: "#243747",
    fillRule: "evenodd",
    d: "M1.91 0A1.9 1.9 0 0 0 0 1.88v12.24A1.9 1.9 0 0 0 1.91 16H20.1a1.9 1.9 0 0 0 1.9-1.88V1.88A1.9 1.9 0 0 0 20.09 0z",
    clipRule: "evenodd"
  }), _jsx("path", {
    fill: "#E61C24",
    fillRule: "evenodd",
    d: "M8.6 11.77A3.8 3.8 0 0 0 12.45 8c0-2.08-1.72-3.76-3.83-3.76S4.78 5.91 4.78 8a3.8 3.8 0 0 0 3.83 3.77",
    clipRule: "evenodd"
  }), _jsx("path", {
    fill: "#F99F1B",
    fillRule: "evenodd",
    d: "M13.36 11.77A3.8 3.8 0 0 0 17.19 8c0-2.08-1.72-3.76-3.83-3.76S9.53 5.91 9.53 8a3.8 3.8 0 0 0 3.83 3.77",
    clipRule: "evenodd"
  }), _jsx("path", {
    fill: "#F26622",
    fillRule: "evenodd",
    d: "M10.98 5.05A3.7 3.7 0 0 0 9.53 8c0 1.15.54 2.24 1.45 2.95A3.7 3.7 0 0 0 12.43 8c0-1.15-.53-2.23-1.45-2.95",
    clipRule: "evenodd"
  })]
}));
IconPaymentMastercard.displayName = 'IconPaymentMastercard';